import { parseGid } from "@redotech/redo-model/shopify/gid-utils";
import { SellingPlanGroup, WidgetFees } from "@redotech/redo-model/widget";
import { getSellingPlanInfo as getSellingPlanInfoApi } from "@redotech/redo-shopify-utils/redo-api";

import type { Shop } from "@shopify/ui-extensions/checkout";

export const getMatchingRedoSellingPlanId = (
  redoProduct: { sellingPlanGroups: SellingPlanGroup[] },
  sellingPlans: any[],
) => {
  const redoSellingPlans = redoProduct.sellingPlanGroups.flatMap(
    (group) => group.sellingPlans,
  );

  const allowedIntervals = sellingPlans
    .filter((plan) => plan.billingPolicy.intervalDays)
    .map((plan) => plan.billingPolicy.intervalDays);

  const matchingSellingPlans = redoSellingPlans
    .filter((plan) => plan.billingPolicy.intervalDays)
    .filter((plan) =>
      allowedIntervals.includes(plan.billingPolicy.intervalDays),
    );

  if (matchingSellingPlans.length === 0) {
    return null;
  }

  const highestFrequencySellingPlan = matchingSellingPlans.reduce(
    (acc, plan) =>
      plan.billingPolicy.intervalDays! < acc.billingPolicy.intervalDays!
        ? plan
        : acc,
  );

  try {
    const id = highestFrequencySellingPlan.id.split("/").slice(-1)[0];
    return id ? parseInt(id) : null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getSellingPlanInfo = async (
  sellingPlanIds: string[],
  fees: WidgetFees | undefined,
  shop: Shop,
  log: (...args: Parameters<typeof console.log>) => void,
) => {
  if (!fees || !sellingPlanIds.length) {
    return undefined;
  }

  const sellingPlanPromises: Promise<any>[] = [];
  for (const sellingPlanId of sellingPlanIds) {
    log(`getting selling plan info for id ${sellingPlanId}`);
    sellingPlanPromises.push(
      getSellingPlanInfoApi(
        shop.myshopifyDomain,
        parseInt(parseGid(sellingPlanId)),
      ),
    );
  }

  const sellingPlanInfo = await Promise.all(sellingPlanPromises);

  log({ sellingPlanInfo });

  if (sellingPlanInfo.length === 0) {
    return undefined;
  }

  const feesItems = [fees.returnProduct, fees.packageProduct, fees.bothProduct];

  const newMapping: Record<string, number> = {};

  for (const feesItem of feesItems) {
    if (feesItem?.sellingPlanGroups) {
      log({ feesSellingPlanGroups: feesItem.sellingPlanGroups });
      const sellingPlanId = getMatchingRedoSellingPlanId(
        feesItem,
        sellingPlanInfo,
      );

      if (sellingPlanId) {
        log({ sellingPlanId });
        newMapping[String(feesItem.productId)] = sellingPlanId;
      }
    }
  }
  log({ sellingPlanMap: newMapping });

  return newMapping;
};
